const NUMERIC_INPUT_ATTRS = {
  inputMode: 'numeric',
  pattern: '[0-9]*'
} as const;

export { NUMERIC_INPUT_ATTRS };
